import axios from 'axios'
import store from '../store'
// import { getToken } from '@/utils/setCooKies'
import {getToken, removeToken, removeUser} from '@/utils/setCooKies'
import {Message, MessageBox} from 'element-ui'

// 创建axios实例
const service = axios.create({
    timeout: 15000// 请求超时时间
});
// request拦截器
service.interceptors.request.use(config => {
    if (store.getters.getUserToken) {
        config.headers['Authorization'] = getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
    }
    return config
}, error => {
    debugger
    // Do something with request error
    console.log("错误", error) // for debug
    Promise.reject(error)
})

// respone拦截器
service.interceptors.response.use(
    response => {
        const res = response.data;
        if (res.code !== 200) {
            if (res.code == 500) {
                MessageBox.confirm(res.message, '执行失败', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    //确定操作
                })
            }
            // 特定为获取验证码判断
            if (response.config.name === "getExcel") {
                return response;
            }
            Message({
                message: res.message,
                type: 'error',
                duration: 3 * 1000
            })
            // 401:未登录;
            if (res.code === 401) {
                removeToken();
                removeUser();
                MessageBox.confirm('你已被登出，可以取消继续留在该页面，或者重新登录', '确定登出', {
                    confirmButtonText: '重新登录',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    //确定操作
                    removeToken();
                    removeUser();

                })
            }
            return Promise.reject('error')
        } else {
            return response.data
        }
    },
    error => {
        console.log('这里抛出错误' + error)// for debug
        Message({
            message: error.message,
            type: 'error',
            duration: 3 * 1000
        })
        return Promise.reject(error)
    }
)

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js